/* tslint:disable */
/* eslint-disable */
export enum QuestionType {
  Question = 'Question',
  Answer = 'Answer'
}
